import React from 'react'
import {Link} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import {setSessionToken} from 'Skelet/src/modules/fetch.action.js'
import {toggleDropdown} from 'Skelet/src/modules/functions.js'
import logo from '../../images/polymedia-citrus.png'


class CoreRouteHeader extends React.Component {

  constructor(props) {
    super(props);
    this.state = {dropdown_open:false, is_scrolling:false};

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('scroll', this.handleScroll);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if(this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({dropdown_open:false});
    }
  }

  handleScroll(e) {
    if(window.pageYOffset === 0) {
      this.setState({is_scrolling:false});
    } else {
      this.setState({is_scrolling:true});
    }
  }

  render() {
    const {account_plan} = this.props;
    return (
      <header className={(this.state.is_scrolling) ? "scrolling" : null}><div className="container">
        <div className="primary">
          <Link to="/" onClick={() => document.getElementById("main").scrollIntoView(true)} className="logo"><img src={logo} alt="Citrus by Polymedia"/></Link>
          {/*<Translator onWhite />*/}
        </div>
        <div className="secondary">
          <nav className="navigation">
            <ol>
              <li className={"nav-item dropdown" + ((this.state.dropdown_open) ? " open" : "")} ref={this.setWrapperRef}>
                <Link to="/settings" className="btn dropdown-toggle" onClick={(e) => toggleDropdown(this, e)}>
                  <span>{this.props.account_data.firstname[0]}</span>
                </Link>
                <div className="dropdown-menu">
                  <div className="dropdown-caret">
                    <span className="caret-outer"></span>
                    <span className="caret-inner"></span>
                  </div>
                  <ul>
                    {/*<li className="sub-item highlight">
                      <Link to="/settings" onClick={() => this.toggleDropdown()}><b>{this.props.account_data.firstname}</b><p>Instellingen</p></Link>
                    </li>
                    <li className="dropdown-divider"></li>*/}
                    <li className="sub-item highlight">
                      <Link to="/settings" onClick={() => {document.getElementById("main").scrollIntoView(true);toggleDropdown(this)}}><b>{this.props.account_data.firstname}</b><p>{this.props.i18n_texts["core_menu_settings"][this.props.app_language]}</p></Link>
                    </li>
                    {(account_plan === "lite" || account_plan === "trial") && <li className="sub-item"><Link to="/settings" onClick={() => {document.getElementById("main").scrollIntoView(true);toggleDropdown(this)}}>{this.props.i18n_texts["core_menu_gopro"][this.props.app_language]}</Link></li>}
                    <li className="dropdown-divider"></li>
                    <li className="sub-item"><Link to="/" onClick={() => {document.getElementById("main").scrollIntoView(true);toggleDropdown(this)}}>{this.props.i18n_texts["core_menu_polls"][this.props.app_language]}</Link></li>
                    <li className="sub-item"><Link to="/quickpolls" onClick={() => {document.getElementById("main").scrollIntoView(true);toggleDropdown(this)}}>{this.props.i18n_texts["core_menu_quickpolls"][this.props.app_language]}</Link></li>
                    {this.props.is_admin && <li className="sub-item"><Link to="/quickpolls-media" onClick={() => {document.getElementById("main").scrollIntoView(true);toggleDropdown(this)}}><i>{this.props.i18n_texts["core_menu_quickpollsmedia"][this.props.app_language]}</i></Link></li>}
                    {this.props.is_admin && <li className="sub-item"><Link to="/dashboard/adminpolls" onClick={() => {document.getElementById("main").scrollIntoView(true);toggleDropdown(this)}}><i>A+Polls</i></Link></li>}
                    {this.props.is_admin && <li className="sub-item"><Link to="/dashboard/adminaccounts" onClick={() => {document.getElementById("main").scrollIntoView(true);toggleDropdown(this)}}><i>A+Accounts</i></Link></li>}
                    {/*<li className="sub-item"><Link to="/" onClick={(e) => {e.preventDefault();document.documentElement.classList.toggle('invert')}}>Invert colors</Link></li>*/}
                    <li className="dropdown-divider"></li>
                    <li className="sub-item"><Link to="/start" target="_blank" onClick={() => toggleDropdown(this)}>Start</Link></li>
                    <li className="sub-item"><Link to="/blog" target="_blank" onClick={() => toggleDropdown(this)}>Blog</Link></li>
                    <li className="sub-item"><Link to="/roadmap" target="_blank" onClick={() => toggleDropdown(this)}>Roadmap</Link></li>
                    <li className="dropdown-divider"></li>
                    <li className="sub-item"><Link to="/" onClick={this.props.logOut}>{this.props.i18n_texts["core_menu_logout"][this.props.app_language]}</Link></li>
                  </ul>
                </div>
              </li>
            </ol>
          </nav>
        </div>
      </div></header>
    );
  }

}


function mapStateToProps(state) {
  let account_data = null, account_plan = null;
  if(state.apiData["login"] !== undefined && state.apiData["login"]["data"]["token"] !== undefined) {
    account_data = state.apiData["login"]["data"];
  }
  if(state.apiData["plan"] !== undefined && state.apiData["plan"]["data"]["name"] !== undefined) {
    account_plan = state.apiData["plan"]["data"]["name"];
    if(state.apiData["login"] !== undefined && state.apiData["login"]["data"]["email"] !== undefined && state.apiData["login"]["data"]["email"] === "hi@peter.plus") {
      account_plan = "premium";
    }
  }
  return {
    account_data: account_data,
    is_admin: (account_data.email === "hi@peter.plus") ? true : false,
    account_plan: account_plan,
    pathname: state.router.location.pathname,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    logOut: () => {document.getElementById("main").scrollIntoView(true);return setSessionToken(null)},
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CoreRouteHeader)



// WEBPACK FOOTER //
// ./src/containers/route-containers/CoreRouteHeader.js